import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/services/auth.service';
import { from, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    return from(auth.getCurrentSession()).pipe(
        catchError(() => of(null)),
        switchMap((session) => {
            const token = session?.tokens?.idToken?.toString();
            if (token) {
                req = req.clone({
                    setHeaders: {
                        Authorization: token,
                    },
                });
            }
            return next(req).pipe(
                tap({
                    error: async (err: any) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status !== 401) {
                                return;
                            }
                            await auth.logout();
                            router.navigate(['auth', 'login']);
                        }
                    },
                }),
            );
        }),
    );
};
